import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JobPosting } from '@models/recruiting/job-posting.model';
import {
    ValidationAttributesInterface,
    ValidationResponseInterface,
    ViolationItem,
} from '@applicant-tracker/interfaces/validation-response.interface';

const endpoint = '/v2/applicantTracker/indeed/jobs/validate';

/**
 * TODO Indeed, new integration - the endpoint no longer exists, delete this class when possible
 * @deprecated
 */
@Injectable({
    providedIn: 'root',
})
export class IndeedValidationService {
    constructor(private http: HttpClient) {}

    parseValidationMessages(validation: ValidationAttributesInterface): ViolationItem[] {
        const violations = validation.violations[0];
        return violations.map((violationItem) => {
            return {
                field: violationItem.field,
                message: violationItem.message.split(':')[2].trim(),
            };
        });
    }

    validateCreateById(jobPostingsIds: number[], employerNumber: string): Promise<ValidationAttributesInterface> {
        return this.http
            .post(endpoint, {
                data: {
                    type: 'jobPostings',
                    attributes: { jobPostings: jobPostingsIds, employerNumber },
                },
            })
            .toPromise()
            .then((res: ValidationResponseInterface) => res.data.attributes);
    }

    validateCreate(jobPosting: JobPosting): Promise<ValidationAttributesInterface> {
        return this.http
            .post(endpoint, jobPosting.toValidatePayload())
            .toPromise()
            .then((res: ValidationResponseInterface) => res.data.attributes);
    }

    validateUpdate(jobPosting: JobPosting): Promise<ValidationAttributesInterface> {
        return this.http
            .put(endpoint, jobPosting.toValidatePayload())
            .toPromise()
            .then((res: ValidationResponseInterface) => res.data.attributes);
    }
}
